import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Touch } from 'vuetify/lib/directives'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'

Vue.use(Vuetify, {
    directives: {
        Touch
    }
})

const opts = {
    breakpoint: {
        scrollBarWidth: 16,
        thresholds: {
            xs: 564,
            sm: 992,
            md: 1280,
            lg: 1920,
        },
    },

    theme: {
        dark: false,
        default: 'light',
        themes: {
            light: {
                primary: '#ffffff',
                secondary: '#f5f5f5',
                secondaryDarker: '#757575',
                textLinks: '#3897f0',
                anchor: '#3897f0',
                starColor: '#FFC850'
            },
            dark: {
                primary: '#000000',
                textLinks: '#3897f0',
                anchor: '#3897f0'
            }
        }
    }
}

const vuetify = new Vuetify(opts)

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi'
})

export default vuetify